var skeleton = tokens => ({
  color: {
    light: {
      backgroundColor: tokens.colors.neutral[80],
      opacity: tokens.opacity['md']
    },
    dark: {
      backgroundColor: tokens.colors.neutral[80],
      backgroundImage: "linear-gradient(\n        -90deg,\n        transparent 40%,\n        ".concat(tokens.colors.neutral[90], " 50%,\n        transparent 60%\n        )")
    }
  },
  shapes: {
    circle: {
      base: {
        borderRadius: tokens.radius['round']
      },
      sizes: {
        small: {
          width: '48px',
          height: '48px'
        },
        medium: {
          width: '80px',
          height: '80px'
        },
        large: {
          width: '120px',
          height: '120px'
        },
        xlarge: {
          width: '160px',
          height: '160px'
        },
        '2xlarge': {
          width: '240px',
          height: '240px'
        }
      }
    },
    rectangle: {
      base: {
        borderRadius: tokens.radius['sm'],
        marginBottom: tokens.spacingY['md']
      },
      heading: {
        height: '40px'
      },
      body: {
        height: '16px'
      }
    }
  }
});
export default skeleton;
//# sourceMappingURL=skeleton.js.map